import * as Popper from '@popperjs/core';
import * as bootstrap from "bootstrap";

window.Popper = Popper;
window.bootstrap = bootstrap;